import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmContractProjectStatusState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmContractProjectStatusState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmContractProjectStatusSlice = createSlice({
  name: 'pmContractProjectStatus',
  initialState,
  reducers: {
    setPmContractProjectStatuses: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmContractProjectStatusesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmContractProjectStatusesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmContractProjectStatuses, setPmContractProjectStatusesLoading, setPmContractProjectStatusesError } =
  PmContractProjectStatusSlice.actions;

export default PmContractProjectStatusSlice.reducer;
